import React, {Component} from "react"
import {connect} from "react-redux"
import {translate} from "react-i18next"

import {Col} from "../../../components/Grid"

import {log, cookie} from "../../../utils"
import api from "../../../services/ApiService"
import DefaultLangSwitch from "./defaultLangSwitch"
import NotificationMailSwitch from "./notificationMailSwitch"
import {vars} from "../../../config"

import {dateToString, checkEnv} from "../../../utils"

class UserInformation extends Component {
  constructor() {
    super()

    this.state = {
      isError: null,
      errorMessage: "",
      updatingLanguage: false,
      updatingNotificationsMail: false
    }
  }

  getRoles(roles) {
    if (Array.isArray(roles)) {
      return roles.map(this._capitalize).join(", ")
    }

    return Object.values(roles)
      .map(this._capitalize)
      .join(", ")
  }

  _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  async uploadAvatar(e) {
    e.preventDefault()
    let file = e.target.parentNode.querySelector(".file").files[0]
    let token = this.props.token
    try {
      const response = await api.postUserAvatar(file, token)
      if (response.status === "success") {
        this.setState({
          isError: false
        })
        this.props.replaceAvatar(response.avatar)
      }
    } catch (e) {
      this.setState({
        isError: true,
        errorMessage: e.message
      })
      log.dir(e)
    }
  }

  async getDefaultLang() {
    return this.props.user.default_lang
  }

  async updateLanguage(lang) {
    this.setState(prevState => {
      return {
        ...prevState,
        updatingLanguage: true
      }
    })

    try {
      const response = await api.setDefaultLang(lang)

      // update default lang – api
      this.props.updateDefaultLang(response.default_lang)

      // set default lang in cookie
      cookie.set(vars.defaultLangCookieName, response.default_lang)

      this.setState(prevState => {
        return {
          ...prevState,
          updatingLanguage: false
        }
      })
    } catch (e) {
      this.setState(prevState => {
        return {...prevState, updatingLanguage: false}
      })
    }
  }

  async updateNotificationsMail(value) {
    this.setState(prevState => {
      return {
        ...prevState,
        updatingNotificationsMail: true
      }
    })

    try {
      const response = await api.setUserNotificationsMail(value)

      // update user notifications mail
      this.props.updateNotificationsMail(response.notifications_mail)
    } catch (e) {
      log.dir(e)
    } finally {
      this.setState(prevState => {
        return {...prevState, updatingNotificationsMail: false}
      })
    }
  }

  renderDefaultLangSwitch() {
    const {user, t} = this.props

    if (checkEnv("HIDE_LANGSWITCH")) return null

    return [
      <li key="langswitch-label">
        <strong>{t("Sprache nach Login")}:</strong>
      </li>,
      <li key="langswitch-input">
        <DefaultLangSwitch
          languages={user.languages}
          defaultLang={user.default_lang}
          updating={this.state.updatingLanguage}
          onSubmit={lang => this.updateLanguage(lang)}
        />
      </li>
    ]
  }

  renderNotificationMailSwitch() {
    const {user, t} = this.props

    if (
      checkEnv("DISABLE_NOTIFICATIONS") ||
      checkEnv("DISABLE_NOTIFICATIONS_MAIL_SETTING")
    )
      return null

    return [
      <li key="notification-label">
        <strong>{t("E-Mail mit Benachrichtigungen")}:</strong>
      </li>,
      <li key="notification-input">
        <NotificationMailSwitch
          initialValue={
            typeof user.notifications_mail !== "undefined" &&
            user.notifications_mail !== ""
              ? user.notifications_mail
              : "yes"
          }
          updating={this.state.updatingNotificationsMail}
          onSubmit={value => this.updateNotificationsMail(value)}
        />
      </li>
    ]
  }

  render() {
    const {user, avatar, lang, t} = this.props

    if (user === undefined) {
      return null
    }
    return (
      <Col lg={8} className="userinformation">
        <div className="card">
          <div className="intro-block">
            <h3 className="headline">{t("Benutzerinformationen")}</h3>
            <p>
              {t(
                "Individualisiere dein Profil und lade ein persönliches Profilbild hoch."
              )}
            </p>
          </div>
          <div className="info-block">
            <Col size={12} md={2} lg={2} xl={2} className="user-avatar">
              <div className="inner">
                <span className={`error ${this.state.isError ? "active" : ""}`}>
                  {this.state.errorMessage}
                </span>
                <img src={avatar} alt="avatar" />
                <i className="icon-edit" />
                <input
                  className="file"
                  type="file"
                  name="fileToUpload"
                  id="fileToUpload"
                  onChange={e => this.uploadAvatar(e)}
                />
              </div>
            </Col>
            <Col size={6} md={5} lg={4} xl={5} className="user-info">
              <ul>
                <li>
                  <strong>{t("Benutzername")}:</strong>
                </li>
                <li>{user.user_nicename}</li>
                <li>
                  <strong>{t("E-Mail Adresse")}:</strong>
                </li>
                <li>{user.user_email}</li>
                {this.renderDefaultLangSwitch()}
              </ul>
            </Col>
            <Col size={6} md={5} lg={6} xl={5} className="global-info">
              <ul>
                <li>
                  <strong>{t("Benutzerrolle")}:</strong>
                </li>
                <li>{this.getRoles(user.roles)}</li>
                <li>
                  <strong>{t("Registriert seit")}:</strong>
                </li>
                <li>{dateToString(user.user_registered, lang, " | ")}</li>
                {this.renderNotificationMailSwitch()}
              </ul>
            </Col>
          </div>
        </div>
      </Col>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang,
    avatar: state.login.avatar,
    token: state.login.token
  }
}

UserInformation = connect(mapStateToProps)(UserInformation)
export default translate()(UserInformation)



// WEBPACK FOOTER //
// ./src/containers/UserProfile/UserInformation/index.js